export function deepCopy<T>(value: T): T {
	return JSON.parse(JSON.stringify(value))
}

export function removeEspecialCharacters(str: string) {
	return str.replace(/[^0-9a-zA-Z]+/g, '')
}
